import { INTEGRATION_NAMES } from './integrations';

// align this list with the one in `functions/constants/integrations` and with the one in
// `_integrationOwnedFieldsWriteIsPermitted` function of the `firestore/firestore.rules` file.
export const INTEGRATIONS_CLIENT_PROFILE_FIELDS = [
  'address1',
  'address2',
  'postalCode',
  'state',
  'city',
  'email',
  'phone',
  'firstName',
  'lastName',
  'gender',
  'birthDate',
  'units',
  'reference',
  'country',
];

// align this list with the one in functions/constants/integrations
export const EXCLUDE_CLIENT_PROFILE_FIELDS_SYNC = {
  [INTEGRATION_NAMES.LUMARY]: ['units'],
};

export const CLIENT_DATA_COLUMN_GROUP = 'clientData';

// Must equal CLIENT_RECOVERY_WINDOW_DAYS in functions/constants/clients.js, which restoreClient
// enforces — a longer value here offers a restore the backend then refuses.
export const CLIENT_RECOVERY_WINDOW_DAYS = 60;

export const CLIENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const EDIT_CLIENT_PROFILE_TABS = {
  PROFILE: 'profile',
  CLINICAL: 'clinical',
  INFORMATION: 'information',
  ACCESS: 'users',
  AVAILABILITY: 'availability',
  AUTHORIZATIONS: 'authorizations',
  COVERAGE: 'coverage',
  BILLING_AUTHORIZATIONS: 'billingAuthorizations',
};
